import axios from "../../axios-instance";
import { fallBackErrorMessage } from "../../constants/event";
import { getAdminBusinessId } from "../../utils/authHelper";

/**
 * add new promo
 * @param {*} options
 */
export const addPromo = (options) => async (dispatch) => {
  const { onSuccess, onError, data } = options || {};

  data.business_id = getAdminBusinessId();

  axios
    .post("admin/settings/promo/save", data)
    .then((res) => {
      const { data: resData } = res || {};
      const { data } = resData || {};
      if (onSuccess) {
        onSuccess(data);
      }
    })
    .catch((error) => {
      if (onError) {
        onError(error);
      }
    });
};

/**
 * Get Promo by code
 * @param {*} options
 * @returns
 */
export const getPromoByCode = (options) => async (dispatch) => {
  const { data, onSuccess, onError } = options || {};
  const { couponCode } = data || {};
  axios
    .get(`/admin/settings/get-promo-by-code/${couponCode}`)
    .then((res) => {
      const { data: resData } = res || {};
      const { data } = resData || {};
      if (onSuccess) {
        onSuccess(data);
      }
    })
    .catch((err) => {
      if (onError) {
        onError(err);
      }
    });
};

/**
 * get promos
 * @param {*} options
 * @returns
 */
export const getPromos = (options) => async (dispatch) => {
  const { data, onSuccess, onError } = options || {};

  data.business_id = getAdminBusinessId();

  axios
    .post("admin/settings/promos", data)
    .then((res) => {
      if (onSuccess) {
        const { data } = res || {};
        onSuccess(data);
      }
    })
    .catch((err) => {
      if (onError) {
        onError(err);
      }
    });
};

/**
 * delete promo
 * @param {*} options
 * @returns
 */
export const deletePromo = (options) => async (dispatch) => {
  const { data, onSuccess, onError } = options || {};
  axios
    .post("admin/settings/promo/delete", data)
    .then((res) => {
      if (onSuccess) {
        const { data } = res || {};
        onSuccess(data);
      }
    })
    .catch((err) => {
      if (onError) {
        onError(err);
      }
    });
};

/**
 * update promo
 * @param {*} options
 */
export const updatePromo = (options) => async (dispatch) => {
  const { onSuccess, onError, data } = options || {};
  axios
    .post("admin/settings/promo/save", data)
    .then((res) => {
      const { data } = res || {};
      if (onSuccess) {
        onSuccess(data);
      }
    })
    .catch((error) => {
      const { data: errorData } = error.response;
      const message =
        errorData.message || error.message || fallBackErrorMessage;
      if (onError) {
        onError(message);
      }
    });
};

/**
 * Get company setting page services
 * @param {*} options
 * @returns
 */
export const getRecurrentDiscounts = (options) => async (dispatch) => {
  const { onSuccess, onError } = options || {};
  axios
    .get("admin/settings/recurrent-discount/" + getAdminBusinessId())
    .then((res) => {
      const { data: resData } = res || {};
      const { data } = resData || {};
      if (onSuccess) {
        onSuccess(data);
      }
    })
    .catch((err) => {
      if (onError) {
        onError(err);
      }
    });
};

/**
 * save recurrent discount
 * @param {*} options
 */
export const saveRecurrentDiscount = (options) => async (dispatch) => {
  const { onSuccess, onError, data } = options || {};
  axios
    .post("admin/settings/recurrent-discount/save", data)
    .then((res) => {
      const { data } = res || {};
      if (onSuccess) {
        onSuccess(data);
      }
    })
    .catch((error) => {
      const { data: errorData } = error.response;
      const message =
        errorData.message || error.message || fallBackErrorMessage;
      if (onError) {
        onError(message);
      }
    });
};
